const cbor = require('cbor');
const cobs = require('cobs');

const { calcCrc16 } = require('./utils');

import UartChannel from './../UartChannel';

let currentId = 0;

function dequeueNextRequestIfIdle(session) {
  if (session.state === 'running') {
    if (session.activeRequest == null) {
      const request = session.requestQueue.shift();
      if (request) {
        request.id = currentId;
        currentId = (currentId + 1) % 65535;
        session.activeRequest = request;

        request.activatedAt = Date.now();

        request.timeoutId = setTimeout(() => {
          request.timeoutId = null;
          request.promiseResolve([-1011, -1]); // RVM_ERROR_TIMEOUT = -1011,
          session.activeRequest = null;
          dequeueNextRequestIfIdle(session);
        }, session.timeout);
        sendUartRpc(session, request);
      }
    }
  }
}


function sendUartRpc(session, request) {
  const { id, method, params } = request;

  const cborBuffer = cbor.encodeOne([id, method, params]);

  const crcBuffer = Buffer.alloc(2);
  crcBuffer.writeUInt16LE(calcCrc16(cborBuffer), 0);

  const txBuffer = cobs.encode(Buffer.concat([cborBuffer, crcBuffer]), true);

  session.send(txBuffer);
}


function sendRpcEventRequest(session) {
  const request = {
    method: 18,
    params: [session.eventBufferOffset],
    queuedAt: Date.now(),
  };

  request.promise = new Promise((resolve, reject) => {
    request.promiseResolve = resolve;
    request.promiseReject = reject;
  });
  session.requestQueue.push(request);
  dequeueNextRequestIfIdle(session);
}


function handleUartRpcRx(session, chunk) {
  let tmpBuffer = null;
  if (Buffer.isBuffer(chunk)) {
    tmpBuffer = chunk;
  } else if (typeof chunk === 'string') {
    tmpBuffer = Buffer.from(chunk);
  } else {
    let str = chunk.toString(16);
    str = str.padStart(str.length + str.length % 2, '0');
    tmpBuffer = Buffer.from(str, 'hex');
  }
  const rxBuffer = Buffer.concat([session.uartRpcRxBuffer, tmpBuffer]);
  // console.log(chunk);

  let rxIndex = 0, rxStart = 0;
  while (rxIndex < rxBuffer.length) {
    if (rxBuffer[rxIndex] === 0) {
      const cobsMessage = rxBuffer.slice(rxStart, rxIndex);
      // console.log('handleUartRpc', { cobsMessage });

      if (cobsMessage.length > 0) {
        const messageBuffer = cobs.decode(cobsMessage);
        // console.log('handleUartRpc', { messageBuffer });

        if (messageBuffer.length >= 2) {
          const crcOffset = messageBuffer.length - 2;
          const storedCrc = messageBuffer.readUInt16LE(crcOffset);
          const calcedCrc = calcCrc16(messageBuffer.slice(0, crcOffset));
          // console.log({ storedCrc, calcedCrc });

          if (storedCrc === calcedCrc) {
            const message = cbor.decodeFirstSync(messageBuffer.slice(0, crcOffset));
            // console.log('handleUartRpc', { message });

            if (Array.isArray(message) && (message.length === 3) && (typeof message[0] === 'number')) {
              const [id, error, result] = message;
              const method = (error != null && result != null) ? error : undefined;
              if (!session.activeRequest) {
                // console.log('Received UART RPC without active request!');
                session.eventEmitter.emit('onionRpcUnexpectedMessage', { id, error, result, method });
              } else if (id !== session.activeRequest.id) {
                // console.log(`Received UART RPC with ID mismatch`);
                session.eventEmitter.emit('onionRpcUnexpectedMessage', { id, error, result, method });
              } else {
                // console.log(`Received UART RPC`);
                session.eventEmitter.emit('onionRpcMessage', {
                  id,
                  error,
                  result,
                  method,
                  activeRequest: session.activeRequest,
                  rawMessageBuffer: cobsMessage,
                });

                if (method == null) { // sonst Echo
                  const request = session.activeRequest;
                  session.activeRequest = null;
                  if (request.method === 18 && (error === null)) { // Method: ReadEventBuffer
                    session.eventBufferOffset = (result[0] + result[1].length) & 0xFFFF; // basisOffset + length
                    if (result[1].length !== 0) { // ggf. mehr anliegende Events
                      sendRpcEventRequest(session);
                    } else {
                      session.eventGpioState = 0; // TODO(robin) Dirty: Warum kommt irgendwann die 0 nicht mehr über den GPIO state?
                    }
                  }

                  if (request.timeoutId != null) {
                    clearTimeout(request.timeoutId);
                    request.timeoutId = null;
                  }
                  request.promiseResolve([error, result]);
                  
                  dequeueNextRequestIfIdle(session);
                }
              }
            }
          }
        }
      }
      rxStart = rxIndex + 1;
    }
    rxIndex += 1;
  }
  session.uartRpcRxBuffer = rxBuffer.slice(rxStart);
}

function checkMessageArguments(method, param) {
  if (typeof method !== 'number') {
    console.log(method, param);
    throw new Error(`OnionRpcChannel Error: 'method' argument must be type number and is: ${typeof method} (${method})`);
  }
  if (!Array.isArray(param)) {
    console.log(method, param);
    throw new Error(`OnionRpcChannel Error: 'param' argument must be type array but is not: ${param}`);
  }
}

class OnionRpcChannel extends UartChannel {
  constructor(name, sendCallback, options) {
    super(name, sendCallback);

    if (!options) {
      options = {};
    }
    this.onionBootupTime = options.onionBootupTime;
    this.session = {
      timeout: options.timeout || 1000,
      lastActiveAt: Date.now(),
      processRpcRxBuffer: Buffer.alloc(0),
      uartRpcRxBuffer: Buffer.alloc(0),
      nextRequestId: 1,
      requestQueue: [],
      activeRequest: null,
      eventEmitter: this,
      eventBufferOffset: 0,
      send: (data) => UartChannel.prototype.send.call(this, data),
      state: options.autoStart != undefined && !options.autoStart ? 'init' : 'running',
      eventGpioState: false,
    };
  }

  receiveData(data) {
    handleUartRpcRx(this.session, data);
  }

  setEventGpioState(state) {
    // console.log('setEventGpioState', state, this.session.eventGpioState, this.session.state, ' ==> ', (state && this.session.eventGpioState !== state));
    if (this.session.state === 'running') {
      const sendEventRequest = (state && this.session.eventGpioState !== state);
      this.session.eventGpioState = state;
      // console.log('gpio state: ', state);
      if (sendEventRequest) {
        sendRpcEventRequest(this.session);
      }
    }
  }

  sendRpcMessage(method, params) {
    checkMessageArguments(method, params);
    const request = {
      method,
      params,
      queuedAt: Date.now(),
    };
    request.promise = new Promise((resolve, reject) => {
      request.promiseResolve = resolve;
      request.promiseReject = reject;
    });
    this.session.requestQueue.push(request);
    dequeueNextRequestIfIdle(this.session);
    return request;
  }

  async sendRpcMessageAndWaitForResponse(method, params) {
    checkMessageArguments(method, params);
    const request = this.sendRpcMessage(method, params);
    return await request.promise;
  }

  start() {
    this.session.state = 'running';
    this.sendRpcMessage(17, []);
    dequeueNextRequestIfIdle(this.session);
  }

  stop(withClear) {
    this.session.state = 'stoped';
    if (withClear) {
      if (this.session.activeRequest && this.session.activeRequest.timeoutId != null) {
        clearTimeout(this.session.activeRequest.timeoutId);
        this.session.activeRequest.timeoutId = null;
      }
      this.session.requestQueue.splice(0, this.session.requestQueue.length);
      this.session.activeRequest = null;
    }
  }
}


export {
  OnionRpcChannel,
};
